export function mountChatWidget(supabase) {
  // ── DOM ──────────────────────────────────────────────────────────────────
  const fab = document.createElement('button');
  fab.id = 'chat-fab';
  fab.title = 'Ask the dashboard assistant';
  fab.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>`;

  const panel = document.createElement('div');
  panel.id = 'chat-panel';
  panel.className = 'chat-panel-hidden';
  panel.innerHTML = `
    <div class="chat-header">
      <div class="chat-header-info">
        <div class="chat-header-title">Dashboard Assistant</div>
        <div class="chat-header-sub">Ask anything about your data</div>
      </div>
      <button class="chat-close" id="chat-close-btn" title="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
    <div class="chat-messages" id="chat-messages">
      <div class="chat-msg chat-msg-assistant">
        <div class="chat-bubble">Hi! Ask me anything about learners, attendance, stipends, or compliance.</div>
      </div>
    </div>
    <div class="chat-input-row">
      <textarea
        id="chat-input"
        class="chat-input"
        placeholder="Ask a question…"
        rows="1"
        maxlength="500"
      ></textarea>
      <button class="chat-send" id="chat-send-btn" title="Send">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
      </button>
    </div>
  `;

  document.body.appendChild(fab);
  document.body.appendChild(panel);

  // ── State ────────────────────────────────────────────────────────────────
  let isOpen    = false;
  let isLoading = false;
  const history = [];   // { role, content }[]

  // ── Helpers ──────────────────────────────────────────────────────────────
  const messagesEl = panel.querySelector('#chat-messages');
  const inputEl    = panel.querySelector('#chat-input');
  const sendBtn    = panel.querySelector('#chat-send-btn');

  function togglePanel() {
    isOpen = !isOpen;
    panel.className = isOpen ? 'chat-panel-open' : 'chat-panel-hidden';
    if (isOpen) { inputEl.focus(); scrollToBottom(); }
  }

  function scrollToBottom() {
    setTimeout(() => { messagesEl.scrollTop = messagesEl.scrollHeight; }, 50);
  }

  function appendMessage(role, text) {
    const div = document.createElement('div');
    div.className = `chat-msg chat-msg-${role}`;
    const bubble = document.createElement('div');
    bubble.className = 'chat-bubble';
    bubble.textContent = text;
    div.appendChild(bubble);
    messagesEl.appendChild(div);
    scrollToBottom();
    return bubble;
  }

  function showTyping() {
    const div = document.createElement('div');
    div.className = 'chat-msg chat-msg-assistant chat-typing-row';
    div.id = 'chat-typing';
    div.innerHTML = `<div class="chat-bubble chat-typing"><span></span><span></span><span></span></div>`;
    messagesEl.appendChild(div);
    scrollToBottom();
  }

  function removeTyping() {
    panel.querySelector('#chat-typing')?.remove();
  }

  function setLoading(val) {
    isLoading = val;
    sendBtn.disabled = val;
    inputEl.disabled = val;
  }

  // ── Send ─────────────────────────────────────────────────────────────────
  async function send() {
    const text = inputEl.value.trim();
    if (!text || isLoading) return;

    inputEl.value = '';
    inputEl.style.height = 'auto';

    appendMessage('user', text);
    history.push({ role: 'user', content: text });

    setLoading(true);
    showTyping();

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('Session expired — please sign in again.');

      const res = await fetch('/api/chat', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ messages: history, userJwt: session.access_token })
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.error || 'Server error');

      removeTyping();
      appendMessage('assistant', json.reply);
      history.push({ role: 'assistant', content: json.reply });
    } catch (err) {
      removeTyping();
      appendMessage('assistant', `Error: ${err.message}`);
    } finally {
      setLoading(false);
      inputEl.focus();
    }
  }

  // ── Events ───────────────────────────────────────────────────────────────
  fab.addEventListener('click', togglePanel);
  panel.querySelector('#chat-close-btn').addEventListener('click', togglePanel);

  sendBtn.addEventListener('click', send);
  inputEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  });

  // Auto-grow textarea
  inputEl.addEventListener('input', () => {
    inputEl.style.height = 'auto';
    inputEl.style.height = Math.min(inputEl.scrollHeight, 120) + 'px';
  });

  // Close on Escape when panel is open
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) togglePanel();
  });
}
